<template>
  <Header></Header>
  <router-view></router-view> <!-- Render routed components -->
  <Footer></Footer>
  <div v-if="loading" class="loading-indicator">Loading...</div> <!-- Loading indicator -->
  <div v-if="error" class="error-message">{{ error }}</div> <!-- Error message -->
</template>

<script>
import $ from 'jquery';
import Header from './components/include/header.vue';
import Footer from './components/include/footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      loading: false, // Loading state
      error: null, // Error message
    };
  },
  methods: {
    checkGuide() {
      const urlParams = new URLSearchParams(window.location.search);
      const email = urlParams.get('email');
      console.log(email);

      if (email) {
        this.loading = true; // Start loading
        this.error = null; // Reset any previous error

        $.ajax({
         url: process.env.VUE_APP_API_URL +'/getBusinessDetails',
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data: { email: email },
          success: (response) => {
            console.log(response);
            if (response.bStatus > 0) {
              window.location.href = '/';
            } else {
              // Use Vue Router to navigate to the business registration page
              this.$router.push({ path: '/verify-business',query: { email: email }});
            }
          },
          error: (xhr, status, error) => {
            console.log('XHR:', xhr);
            console.log('Status:', status);
            console.log('Error:', error);
            this.error = 'An error occurred while checking your business details. Please try again.'; // Set error message
          },
          complete: () => {
            this.loading = false; // Stop loading when the request is complete
          },
        });
      }
    },
  },
  mounted() {
    if (window.location.pathname === '/verify-business') {
      this.checkGuide();
    }
  },
};
</script>

<style>
.loading-indicator {
  /* Add styles for the loading indicator */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  color: #007bff;
  /* Bootstrap primary color */
}

.error-message {
  color: red;
  /* Error message color */
  margin: 20px;
}
</style>
